export default __webpack_public_path__ + "static/media/VineThumb.e1687adf.png";